import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material';

/**
 * @param {any} props
 * @returns animated Pop Up UI
 */
function Animated(props) {
  const { requestOpen, onEnter, onExited, children, className } = props;

  useEffect(() => {
    if (requestOpen) {
      onEnter();
    }
  }, [onEnter, requestOpen]);

  const handleAnimationEnd = useCallback(() => {
    if (!requestOpen) {
      onExited();
    }
  }, [onExited, requestOpen]);

  return (
    <div onAnimationEnd={handleAnimationEnd} className={className + (requestOpen ? ' open' : ' close')}>
      {children}
    </div>
  );
}

// popup input parameter definition
Animated.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onEnter: PropTypes.func.isRequired,
  onExited: PropTypes.func.isRequired,
  requestOpen: PropTypes.bool.isRequired,
};

export const POPUP_DURATION_SUCCESS = 2000;
export const POPUP_DURATION_ERROR = 4000;
export const POPUP_DURATION_DELAY = 3000;

// popup animation custom style
export const PopAnimation = styled(Animated)`
  @keyframes open-animation {
    0% {
      opacity: 0;
      transform: translateY(-8px) scale(0.95);
    }

    50% {
      opacity: 1;
      transform: translateY(4px) scale(1.05);
    }

    100% {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @keyframes close-animation {
    0% {
      opacity: 1;
      transform: translateY(0) scale(1);
    }

    50% {
      opacity: 1;
      transform: translateY(4px) scale(1.05);
    }

    100% {
      opacity: 0;
      transform: translateY(-8px) scale(0.95);
    }
  }

  &.open {
    animation: open-animation 0.4s ease-in forwards;
  }

  &.close {
    animation: close-animation 0.4s ease-in forwards;
  }
`;

// popup background custom style for success message
export const PopupSuccessBody = styled('div')(`
    padding: 0.5rem 1rem;
    margin: 8px;
    border: 1px solid #d0d7de;
    background-color: #00a76f;
    color: white;
    border-radius: 8px;
    box-shadow: 0px 4px 8px rgb(0 0 0 / 0.1);
    min-height: 3rem;
    display: flex;
    align-items: center;
`);

// popup background custom style for error message
export const PopupErrorBody = styled('div')(`
    text-align: center;
    padding: 0.5rem 1rem;
    margin: 8px;
    border: 1px solid #d0d7de;
    background-color: #bf0001;
    color: white;
    border-radius: 8px;
    box-shadow: 0px 4px 8px rgb(0 0 0 / 0.1);
    min-height: 3rem;
    display: flex;
    align-items: center;
`);
